import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import cn from "clsx";
import { selectPDPProductInfo, selectProductDetails } from "../selectors";
import {
  selectCommonSettings,
  selectLanguageSlug
} from "../../../util/selectors";
import { handleGoBack } from "../../../util/common";
import AddToWishlistButton from "@/components/product/addToWishlistButton";
import { TopMobileContentProps } from "./types";

const SCROLL_EQUATOR_VALUE = 460;

const TopMobileContent = ({
  itemDetailWrapperRef,
  selectedSizeFullData
}: TopMobileContentProps) => {
  const [isWhiteStrip, setIsWhiteStrip] = useState(false);

  const item = useSelector(selectProductDetails);
  const history = useHistory();
  const location = useLocation();

  const language = useSelector(selectLanguageSlug);
  const commonSettings = useSelector(selectCommonSettings);
  const { brand, title } = useSelector(selectPDPProductInfo);
  const prevScrollY = useRef(0);
  const iconRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (itemDetailWrapperRef?.current) {
        if (window.pageYOffset >= SCROLL_EQUATOR_VALUE && !isWhiteStrip) {
          setIsWhiteStrip(true);
        } else if (window.pageYOffset <= SCROLL_EQUATOR_VALUE && isWhiteStrip) {
          setIsWhiteStrip(false);
        }
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isWhiteStrip]);

  return (
    <div
      className={cn("product_top_wish_list", {
        whiteStrip: isWhiteStrip
      })}
    >
      <span
        className="back_icon"
        onClick={() =>
          handleGoBack(location, history, language, commonSettings)
        }
      />
      <p className="productHighlight">
        {brand.label && <span>{brand.label}</span>}
        {title.label && <span>{title.label}</span>}
      </p>
      {item.isPriceAvailableInUserCountry && (
        <AddToWishlistButton
          product={item}
          iconRef={iconRef}
          selectedSizeFullData={selectedSizeFullData}
        />
      )}
    </div>
  );
};

export default TopMobileContent;
